import React from "react";
import { useUpsellWidgetUserFormContext } from "../../../hooks/useUpsellWidgetUserFormContext";

export const FirstNameInput = ({ register, errors }) => {
    const { userFormProps, updateUserForm } = useUpsellWidgetUserFormContext();
    return <div className="form-group mb-2">
        <input
            className={`form-control ${errors.firstName && 'upsell-input-invalid'}`}
            type="text"
            defaultValue={userFormProps.firstName || ""}
            placeholder="First name"
            {...register("firstName", {
                required: "First name is required",
                onBlur: async (event) => {
                    updateUserForm({ firstName: event.target.value });
                }
            })} />
        {errors.firstName && <div className="upsell-input-error">{errors.firstName.message}</div>}
    </div>;
};